import React from 'react';

function QuickActionsBar({ navigate }) {
  // Handle actions with proper navigation
  const handleNewClient = () => {
    navigate('/therapist/client-profile');
  };
  
  const handleBilling = () => {
    navigate('/therapist/daily-log-multi');
  };
  
  const handleNotes = () => {
    navigate('/therapist/notes');
  };
  
  const handleResources = () => {
    navigate('/therapist/resources');
  };
  
  return (
    <div style={cardStyle}>
      <h3 style={cardTitleStyle}>Quick Actions</h3>
      
      <div style={quickActionsContainerStyle}>
        <button 
          style={{ ...quickActionButtonStyle, backgroundColor: '#EBF5FF', border: '1px solid #BFDBFE' }}
          onClick={handleNewClient}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={quickActionIconStyle}>
            <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span style={quickActionTextStyle}>New Client</span>
        </button>
        
        <button 
          style={{ ...quickActionButtonStyle, backgroundColor: '#F5F3FF', border: '1px solid #DDD6FE' }}
          onClick={handleNotes}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ ...quickActionIconStyle, color: '#8B5CF6' }}>
            <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M18.5 2.5C18.8978 2.10217 19.4374 1.87868 20 1.87868C20.5626 1.87868 21.1022 2.10217 21.5 2.5C21.8978 2.89782 22.1213 3.43739 22.1213 4C22.1213 4.56261 21.8978 5.10217 21.5 5.5L12 15L8 16L9 12L18.5 2.5Z" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span style={quickActionTextStyle}>Session Notes</span>
        </button>
        
        <button 
          style={{ ...quickActionButtonStyle, backgroundColor: '#FFFBEB', border: '1px solid #FDE68A' }}
          onClick={handleBilling}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ ...quickActionIconStyle, color: '#F59E0B' }}>
            <path d="M12 1V23" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span style={quickActionTextStyle}>Billing</span>
        </button>
        
        <button 
          style={{ ...quickActionButtonStyle, backgroundColor: '#ECFDF5', border: '1px solid #A7F3D0' }}
          onClick={handleResources}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ ...quickActionIconStyle, color: '#10B981' }}>
            <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span style={quickActionTextStyle}>Resources</span>
        </button>
      </div>
    </div>
  );
}

// STYLES
const cardStyle = {
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: '24px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
  border: '1px solid #E5E7EB'
};

const cardTitleStyle = {
  fontSize: '1.25rem',
  fontWeight: '600',
  marginTop: 0,
  marginBottom: '16px'
};

const quickActionsContainerStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
  gap: '16px'
};

const quickActionButtonStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px 16px', // Increased vertical padding
  borderRadius: '8px',
  border: 'none',
  cursor: 'pointer',
  transition: 'transform 0.2s, box-shadow 0.2s',
  boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
  ':hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
  }
};

const quickActionIconStyle = {
  marginBottom: '12px', // Increased spacing
  color: '#3B82F6'
};

const quickActionTextStyle = {
  fontSize: '1rem', // Increased font size
  fontWeight: '600', // Made bold for better readability
  color: '#1F2937', // Very dark text for better contrast
  marginTop: '6px'
};

export default QuickActionsBar;